import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWithTokenManagement from '../../pages/auth/apiSlice';
import { USER_TYPES } from '../../constants';
import { usersApi } from '../user';

export interface WarehouseUser {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  role: string;
  isWarehouseUser: boolean;
  permissions: string[];
}

// Create RTK Query API for warehouse operations
export const warehouseApi = createApi({
  reducerPath: 'warehouseApi',
  baseQuery: baseQueryWithTokenManagement,
  tagTypes: ['WarehouseAuth'],
  endpoints: (builder) => ({
    warehouseLogin: builder.mutation<any, any>({
      query: (credentials) => ({
        url: '/auth/admin', // Using same endpoint for now
        method: 'POST',
        body: { ...credentials, loginType: USER_TYPES.WAREHOUSE },
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          if (data?.id) {
            localStorage.setItem('warehouse_user', JSON.stringify({ ...data, isWarehouseUser: true }));
            localStorage.setItem('warehouse_userId', JSON.stringify(data.id));
            localStorage.setItem('userId', JSON.stringify(data.id));
            localStorage.setItem('application', JSON.stringify(USER_TYPES.WAREHOUSE));
          }
          dispatch(usersApi.util.invalidateTags(['USER']));
        } catch (error) {
          console.error('Authentication failed:', error);
        }
      },
    }),
  }),
});

export const { useWarehouseLoginMutation } = warehouseApi;

// Utility functions for local storage
export const warehouseAuthAPI = {
  logout: (): void => {
    localStorage.clear();
  },

  getCurrentUser: (): WarehouseUser | null => {
    try {
      const userStr = localStorage.getItem('warehouse_user');
      return userStr ? JSON.parse(userStr) : null;
    } catch {
      return null;
    }
  },

  setUser: (user: WarehouseUser): void => {
    localStorage.setItem('warehouse_user', JSON.stringify(user));
  },
};
